/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsGDPRService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './SalesDocumentsGDPRService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsGDPRService#getConsentFormWrap
 */
export const GET_CONSENT_FORM_WRAP_QUERY_FIELD_NAME = 'com_hubspot_sales_documents_rpc_SalesDocumentsGDPRService_getConsentFormWrap';
export const GET_CONSENT_FORM_WRAP_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CONSENT_FORM_WRAP_QUERY_FIELD_NAME,
  args: ['documentId', 'accessId', 'lang'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getConsentFormWrapRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsGDPRService#getGdprWrap
 */
export const GET_GDPR_WRAP_QUERY_FIELD_NAME = 'com_hubspot_sales_documents_rpc_SalesDocumentsGDPRService_getGdprWrap';
export const GET_GDPR_WRAP_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_GDPR_WRAP_QUERY_FIELD_NAME,
  args: ['documentId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getGdprWrapRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsGDPRService#submitViewerForm
 */
export const SUBMIT_VIEWER_FORM_MUTATION_FIELD_NAME = 'com_hubspot_sales_documents_rpc_SalesDocumentsGDPRService_submitViewerForm';
export const SUBMIT_VIEWER_FORM_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SUBMIT_VIEWER_FORM_MUTATION_FIELD_NAME,
  args: ['documentId', 'communicationTypeId', 'accessId', 'formGuid', 'email', 'consentReceived', 'legalConsentOptions'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.submitViewerFormRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsGDPRService#updateSettings
 */
export const UPDATE_SETTINGS_MUTATION_FIELD_NAME = 'com_hubspot_sales_documents_rpc_SalesDocumentsGDPRService_updateSettings';
export const UPDATE_SETTINGS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_SETTINGS_MUTATION_FIELD_NAME,
  args: ['documentId', 'request'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.updateSettingsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});